import { Avatar, Badge, Button, Image, Popconfirm, Popover, Steps } from "antd";
import { FC, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    closePorteFeuilleDrawer__,
    closeProfileDrawer,
    logout,
    openProfileDrawer,
} from "store/auth/authSlice";
import {
    closePaiementDrawer,
    openChatDrawerStudent,
    openPaiementDrawer,
} from "store/chat/mainSlice";

import * as appRoutes from "config/routes.config";
import { useTranslation } from "react-i18next";
import { Link, NavLink, useNavigate } from "react-router-dom";

//!COMPONENTS

//!IMAGES
import logo from "assets/images/app/header/logo.svg";

import AvatarIcon from "../../assets/images/app/avatar_icon.svg";
import Students from "../../assets/images/app/iam_student.svg";
import Classes from "./assets/images/mesclasse.svg";
import FindTeacher from "./assets/images/prof.svg";
import Wallet from "./assets/images/wallet.svg";

import ArrowDown from "../../assets/images/app/arrow_bottom_down.svg";
import ArrowUp from "../../assets/images/app/arrow_top_up.svg";
import DollarIcon from "../../assets/images/app/dollar-coins.png";
import Calendar from "../../assets/images/app/header/calendar.svg";
import OrganismProfile from "../../assets/images/app/iam_organism.svg";
import Teachers from "../../assets/images/app/iam_teacher.svg";
import LogoutIcon from "../../assets/images/app/logout_icon.svg";
import Msg from "../../assets/images/app/messagerie.svg";
import MenuIcon from "../../assets/images/app/new_menu.svg";

//!STYLES
import MenuModal from "screens/teacher/components/menu";
import "./assets/navStyle.css";
import style from "./assets/user.header.module.css";

//!REDUX
import { UserRoles } from "common/enums";
import NotificationParentOrganism from "components/notifications/parentOrganisme";
import { toggleAppChat } from "store/AppChat/appChat";
import { clearRoom } from "store/chat/roomSlice";
import { clearRooms } from "store/chat/roomsSlice";
import { useGetNotifByUserQuery, useViewNotifByUserMutation } from "store/services/teacher/notification.services";
import NavUser from "./NavUser";
import WhenParentOrganismeNotConnected from "./header.parent";

const { Step } = Steps;

const UserParentOrganisation: FC = () => {
    //!HOOKS
    const { isLoggedIn } = useSelector((state) => state.auth);
    const { isFullscreen } = useSelector((state) => state.app);
    const { isRegistering } = useSelector((state) => state.app);

    //!RETURN
    return (
        <div>
            {isLoggedIn && !isFullscreen && !isRegistering && <WhenParentOrganismConnected />}
            {isLoggedIn && !isFullscreen && isRegistering && <WhenParentOrganismeNotConnected />}
            {!isLoggedIn && <WhenParentOrganismeNotConnected />}
        </div>
    );
};

const WhenParentOrganismConnected: FC = () => {

    //!HOOKS
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { user } = useSelector((state) => state.auth);
    const { currentChat } = useSelector((state) => state.appChat);
    const isParent = user?.roles?.includes(UserRoles.PARENT);

    const { socket } = useSelector((state) => state.appChat);

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
    const handleResize = () => {
        setIsMobile(window.innerWidth <= 767);
    };
    window.addEventListener('resize', handleResize);

    const [visibleOptions, setVisibleOptions] = useState(false);
    const [wantDisconnect, setWantDisconnect] = useState(false);
    const popoverReportRef = useRef<HTMLDivElement>(null);

    //!STATE
    const [visible, setVisible] = useState(false);

    const openMessagerieDrawer = () => {
        dispatch(openChatDrawerStudent());
        dispatch(closeProfileDrawer());
        dispatch(closePorteFeuilleDrawer__());
        dispatch(closePaiementDrawer());
        setVisible(false);
    };

    const openPaiementStudentDrawer = () => {
        dispatch(openPaiementDrawer());
    };
    //!FUNCTIONS

    const openDrawer = () => {
        dispatch(openProfileDrawer());
        setSeeProfile(false);
    };

    const [seeProfile, setSeeProfile] = useState(false);

    const menuParent = [
        {
            id: 1,
            name: "Mes élèves",
            icon: Students,
            iconSize: 28,
            link: isParent ? appRoutes.PARENT_DASHBOARD : appRoutes.ORGANISM_DASHBOARD,
        },
        {
            id: 2,
            name: "Annuaire des profs",
            icon: FindTeacher,
            iconSize: 30,
            link: isParent ? appRoutes.FIND_STUDENT_TEACHER : appRoutes.ORGANISM_FIND_STUDENT_TEACHER,
        },
        /* {
            id: 3,
            name: "Messagerie",
            icon: Message,
            iconSize: 25,
            link: "#",
        }, */
        {
            id: 4,
            name: "Portefeuille",
            icon: Wallet,
            iconSize: 30,
            link: isParent ? appRoutes.WALLETS : appRoutes.ORGANISM_WALLETS,
        },
    ];

    const menuOrganism = [
        {
            id: 0,
            name: "Mes classes",
            icon: Classes,
            iconSize: 28,
            link: isParent ? appRoutes.PARENT_CLASSES : appRoutes.ORGANISM_CLASSES,
        },
        {
            id: 1,
            name: "Mes élèves",
            icon: Students,
            iconSize: 28,
            link: isParent ? appRoutes.PARENT_DASHBOARD : appRoutes.ORGANISM_DASHBOARD,
        },
        {
            id: 6,
            name: "Mes profs",
            icon: Teachers,
            iconSize: 28,
            link: appRoutes.ORGANISM_TEACHERS,
        },
        {
            id: 2,
            name: "Annuaire des profs",
            icon: FindTeacher,
            iconSize: 30,
            link: isParent ? appRoutes.FIND_STUDENT_TEACHER : appRoutes.ORGANISM_FIND_STUDENT_TEACHER,
        },
        {
            id: 5,
            name: "Mon calendrier",
            icon: Calendar,
            iconSize: 35,
            link: appRoutes.ORGANISM_CALENDAR,
        },
        /* {
            id: 3,
            name: "Messagerie",
            icon: Message,
            iconSize: 25,
            link: "#",
        }, */
        {
            id: 4,
            name: "Portefeuille",
            icon: Wallet,
            iconSize: 30,
            link: isParent ? appRoutes.WALLETS : appRoutes.ORGANISM_WALLETS,
        },
    ];

    const [
        viewNotifByUser,
        { data: viewData, isLoading: isLoadingView, isSuccess: isSuccessView },
    ] = useViewNotifByUserMutation();

    const {
        data: dataNotif,
        refetch,
        isLoading,
    } = useGetNotifByUserQuery(user._id);

    let filterNotifForMsg =
        dataNotif?.data?.filter(
            (data: any) => data?.type === "messagerie" && data?.seen === false
        ) || [];

    const resetCount = async () => {
        let result =
            dataNotif?.data?.filter((element: any) => {
                return element?.seen === false;
            }) || [];

        await result?.forEach((element: any) => {
            if (element?._id) {
                viewNotifByUser(element?._id);
            }
        });
    };

    const openChat = () => {
        dispatch(toggleAppChat(true));
        resetCount();
        ///handleViewAllMessage(filterNotifForMsg);
    }

    const clearCookies = () => {
        document.cookie.split(";").forEach((c) => {
            document.cookie = c
                .replace(/^ +/, "")
                .replace(/=.*/, "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/");
        });
    };

    const disconnect = async () => {
        setWantDisconnect(false);
        await socket.emit("unsubscribe", user?._id);
        socket?.disconnect();
        dispatch(clearRoom());
        dispatch(clearRooms());
        dispatch(logout());
        clearCookies();
        localStorage.removeItem("couponCode");
        localStorage.clear();
        sessionStorage.clear();
    };

    const handleClickOutside = (event: MouseEvent) => {
        setTimeout(() => {
            if (popoverReportRef.current && !popoverReportRef.current.contains(event.target as Node)) {
                if (seeProfile || wantDisconnect) {
                    console.log("Action selected!");
                } else {
                    setVisibleOptions(false);
                }
            }
        }, 200);
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [seeProfile, wantDisconnect]);

    const content = (
        <div onClick={(e) => e.stopPropagation()} style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "flex-start" }}>
            <div style={{ fontSize: isMobile ? "0.8em" : "13px", cursor: "pointer", display: "flex", flexDirection: "column" }}>
                <span style={{ color: "#80b1b2" }}>{user?.lastname}</span>
            </div>
            <div style={{ height: "1px", width: "90%", margin: "0px auto", background: "#BFBCBC", marginTop: "5px", marginBottom: "5px" }}></div>
            <div onClick={() => { setSeeProfile(true); openDrawer() }} style={{ fontSize: isMobile ? "0.8em" : "12px", color: "#464c4c", cursor: "pointer", display: "flex", flexDirection: "row", borderRadius: "5px", background: "#e5f5f5", alignItems: "center", justifyContent: "center", width: "100%", height: "30px", paddingLeft: "5px", paddingRight: "5px" }}>
                <img src={user?.profil || AvatarIcon} height={15} style={{ marginRight: "5px" }}></img>
                Mon profil
            </div>
            <Popconfirm
                placement="left"
                title={"Tu confirmes la déconnexion ?"}
                onConfirm={disconnect}
                onCancel={() => setWantDisconnect(false)}
                okText="Oui"
                cancelText="Non"
            >
                <Button onClick={() => setWantDisconnect(true)} style={{ fontSize: isMobile ? "0.8em" : "12px", color: "#f67675", cursor: "pointer", display: "flex", flexDirection: "row", borderRadius: "5px", background: "#ffeae5", alignItems: "center", justifyContent: "center", width: "100%", height: "30px", marginTop: "5px", paddingLeft: "5px", paddingRight: "5px" }}>
                    <img src={LogoutIcon} height={15} style={{ marginRight: "5px" }}></img>
                    Se déconnecter
                </Button>
            </Popconfirm>
        </div>
    );

    const contentMobile = (
        <div onClick={(e) => e.stopPropagation()} style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "flex-start", width: "100%" }}>
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", textAlign: "center", width: "100%" }}>
                <div style={{ fontSize: isMobile ? "0.8em" : "13px", cursor: "pointer", display: "flex", flexDirection: "column" }}>
                    <span style={{ color: "#80b1b2", textTransform: "capitalize" }}>{user?.lastname}</span>
                </div>

                <div onClick={() => { setSeeProfile(true); openDrawer() }} style={{ fontSize: isMobile ? "0.8em" : "12px", color: "#464c4c", cursor: "pointer", display: "flex", flexDirection: "row", borderRadius: "5px", background: "#e5f5f5", alignItems: "center", justifyContent: "center", height: "30px", paddingLeft: "5px", paddingRight: "5px" }}>
                    <img src={user?.profil || AvatarIcon} height={12} style={{ marginRight: "5px" }}></img>
                    Mon profil
                </div>

                <Popconfirm
                    placement="left"
                    title={"Tu confirmes la déconnexion ?"}
                    onConfirm={disconnect}
                    onCancel={() => setWantDisconnect(false)}
                    okText="Oui"
                    cancelText="Non"
                >
                    <Button onClick={() => setWantDisconnect(true)} style={{ fontSize: isMobile ? "0.8em" : "12px", color: "#f67675", cursor: "pointer", display: "flex", flexDirection: "row", borderRadius: "5px", background: "#ffeae5", alignItems: "center", justifyContent: "center", height: "30px", paddingLeft: "5px", paddingRight: "5px" }}>
                        <img src={LogoutIcon} height={15} style={{ marginRight: "5px" }}></img>
                        Se déconnecter
                    </Button>
                </Popconfirm>
            </div>
        </div>
    );

    //!RETURN
    return (
        <>
            <div className={style.header} style={{}}>

                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%", maxWidth: isMobile ? "360px" : "1200px", margin: "0px auto", height: "70px" }}>
                    <div className={style.menu} style={{ display: "flex", flexDirection: "row", width: isMobile ? "100%" : "15%", alignItems: "center", justifyContent: "space-between", padding: "0px" }}>
                        <div className={style.logo}>
                            <Link to={isParent ? appRoutes.PARENT_DASHBOARD : appRoutes.ORGANISM_DASHBOARD}>
                                <img src={logo} height={50} alt="logo" ></img>
                            </Link>
                        </div>

                        <div
                            className={style.header__menu}
                            onClick={() => setVisible(!visible)}
                        >
                            <img src={MenuIcon} alt="" width={26} />
                        </div>
                    </div>

                    {!isMobile && <div style={{ display: "flex", flexDirection: "row", width: "auto" }}>
                        <nav className={style.nav__bar} style={{ marginRight: "10px" }}>
                            <ul className={style.nav__item_organism}>
                                {isParent ? menuParent.map((item) => (
                                    <li className={style.__isMobile}>
                                        <ul>
                                            <li className={style.navbarItemBox}>
                                                <Link to={item?.link} onClick={() => item.name === "Messagerie" ? openChat() : {}}>
                                                    {item.id === 3 && filterNotifForMsg?.length > 0 && <li style={{ height: 20, width: 20, background: "red", color: "white", borderRadius: "50%", textAlign: "center", position: "relative", top: "10px", right: "-30px", zIndex: "77" }}>{filterNotifForMsg?.length}</li>}
                                                    <Image
                                                        preview={false}
                                                        src={item.icon}
                                                        width={item?.iconSize || 29}
                                                        style={{ position: "relative", top: item.id === 3 && filterNotifForMsg?.length > 0 ? "-10px" : "0px" }}
                                                    />
                                                </Link>
                                            </li>
                                            <li>
                                                {" "}
                                                <NavLink
                                                    to={item.link}
                                                    onClick={() => item.name === "Messagerie" ? openChat() : {}}
                                                    className={({ isActive }) =>
                                                        isActive ? "activeLink" : ""
                                                    }
                                                >
                                                    {item.name}
                                                </NavLink>
                                            </li>
                                        </ul>
                                    </li>
                                )) : menuOrganism.map((item) => (
                                    <li className={style.__isMobile}>
                                        <ul>
                                            <li className={style.navbarItemBox}>
                                                <Link to={item?.link} onClick={() => item.name === "Messagerie" ? openChat() : {}}>
                                                    {item.id === 3 && filterNotifForMsg?.length > 0 && <li style={{ height: 20, width: 20, background: "red", color: "white", borderRadius: "50%", textAlign: "center", position: "relative", top: "10px", right: "-30px", zIndex: "77" }}>{filterNotifForMsg?.length}</li>}
                                                    <Image
                                                        preview={false}
                                                        src={item.icon}
                                                        width={item?.iconSize || 29}
                                                        style={{ position: "relative", top: item.id === 3 && filterNotifForMsg?.length > 0 ? "-10px" : "0px" }}
                                                    />
                                                </Link>
                                            </li>
                                            <li>
                                                {" "}
                                                <NavLink
                                                    to={item.link}
                                                    onClick={() => item.name === "Messagerie" ? openChat() : {}}
                                                    className={({ isActive }) =>
                                                        isActive ? "activeLink" : ""
                                                    }
                                                >
                                                    {item.name}
                                                </NavLink>
                                            </li>
                                        </ul>
                                    </li>
                                ))}

                                <div className="balance-card">
                                    <div className="balance-left">
                                        <div className="balance-text">
                                            <div className="balance-icon-text">
                                                <img src={DollarIcon} height={20} style={{ marginRight: "5px" }} />
                                                <span className="balance-title">Solde</span>
                                            </div>

                                            <span className="balance-amount">
                                                {user?.coins} <small>EUR</small>
                                            </span>
                                        </div>
                                    </div>

                                    <div className="balance-info">i</div>
                                </div>

                                {/* <ParentOrganismNavBar user={user} /> */}

                                <li>
                                    <Badge size="small" count={filterNotifForMsg?.length} offset={[-5, 5]}>
                                        <div
                                            onClick={() => {
                                                openChat();
                                            }}
                                            className={style.menuBoxMessage}
                                        >
                                            <div className={style.menuItemBox}>
                                                <Image preview={false} src={Msg} width={25} />
                                            </div>
                                            <span className={style.menuTitle}>Messages</span>
                                        </div>
                                    </Badge>
                                </li>

                                <li>
                                    <NotificationParentOrganism
                                        dataNotif={dataNotif}
                                        refetch={refetch}
                                        viewNotifByUser={viewNotifByUser}
                                        isLoading={isLoading}
                                    />
                                </li>

                                <li className={style.menuBox} onClick={() => setVisible(true)} style={{ marginLeft: "0px" }}>
                                    <div className={style.menuItemBox}><Image preview={false} src={MenuIcon} width={27} /></div>
                                    <span className={style.studentMenuTitle}>Menu</span>
                                </li>
                            </ul>
                        </nav>
                        {!isMobile && <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", height: "65px", width: "75px" }}>
                            <img src={user?.profile || OrganismProfile} height={60} style={{ border: "2px solid #80b1b2", borderRadius: "50%" }} />
                            <Popover
                                visible={visibleOptions}
                                placement="bottom"
                                content={content}
                                trigger="click"
                                style={{ height: "70px !important", width: "350px !important", borderRadius: "8px", boxShadow: "4px 8px 16px #8B8B8B38", border: "0.5px solid #BFBCBC" }}
                            >
                                <div ref={popoverReportRef} onClick={(e: any) => { e.stopPropagation(); setVisibleOptions(!visibleOptions); }}><img src={visibleOptions ? ArrowUp : ArrowDown} height={17}></img></div>
                            </Popover>
                        </div>}
                    </div>}

                    {/* Mobile */}
                    {isMobile && <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", width: "auto", gap: "5px" }}>
                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", height: "50px", width: "75px" }}>
                            <Avatar
                                style={{ backgroundColor: "#FFF", border: "1px solid #80b1b2", marginRight: "5px" }}
                                size={35}
                                src={
                                    <Image
                                        fallback={`http://gravatar.com/avatar${user?.uid}?d=identicon`}
                                        preview={false}
                                        src={
                                            !!user?.profile
                                                ? user?.profile
                                                : `https://gravatar.com/avatar/${user?._id}?d=identicon`
                                        }
                                    />
                                }
                            >
                                {""}
                            </Avatar>
                            <Popover
                                visible={visibleOptions}
                                placement="bottom"
                                content={contentMobile}
                                trigger="click"
                                overlayStyle={{ left: 0, right: 0 }}
                                style={{ left: 0, right: 0 }}
                                overlayInnerStyle={{ left: 0, right: 0 }}
                                overlayClassName="student-popover"
                            >
                                <div ref={popoverReportRef} onClick={(e: any) => { e.stopPropagation(); setVisibleOptions(!visibleOptions); }}><img src={visibleOptions ? ArrowUp : ArrowDown} height={17}></img></div>
                            </Popover>
                        </div>
                    </div>}
                </div>

            </div>

            <MenuModal
                visible={visible}
                setVisible={setVisible}
                openDrawer={openDrawer}
                openMessagerieDrawerStudent={openMessagerieDrawer}
                openPaiementDrawer={openPaiementStudentDrawer}
            />

            {!currentChat && (
                <NavUser
                    openMessagerieDrawer={openMessagerieDrawer}
                    visible={visible}
                    setVisible={setVisible}
                />
            )}

        </>
    );
};

export default UserParentOrganisation;
